import { IInitialState } from 'store/models';

export function moduleStateSelector(state: IInitialState) {
	return state.survey;
}
